import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import useRecommendedProductList from "../hooks/useRecommendedProductList";
import { formatCurrencyLocal, formatNumberLocal } from "../utils/stringManipulator";

const NewArrivalTwo = ({ productId, isWholesale }) => {
  const {
    fetchRecommendedProductList,
    data,
    total,
    status,
    error,
    resetStatus,
  } = useRecommendedProductList();

  const [productRecommended, setProductRecommended] = useState([]);

  useEffect(() => {
    if (productId && productId !== undefined) {
      fetchRecommendedProductList({
        skip: 0,
        take: 100,
        filter: "",
        startDate: null,
        endDate: null,
        quickFilter: [],
        sort: null,
        productId: productId,
      });
    }
  }, [productId]);

  useEffect(() => {
    if (data && Array.isArray(data) && data.length > 0) {
      // if data is less than 6, fill with same data to make it 6 items
      if (data.length < 6) {
        const filledData = [...data];
        while (filledData.length < 6) {
          filledData.push(...data);
        }
        setProductRecommended(filledData.slice(0, 6));
      } else {
        setProductRecommended(data);
      }
    } else {
      setProductRecommended([]);
    }
  }, [data]);

  //console.log("Recommended Products:", productRecommended);

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  }
  function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-one-600 text-xl hover-bg-main-one-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  }
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <section className="new-arrival pb-80">
      <div className="container container-md">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h5 className="mb-0 text-2xl">You Might Also Like</h5>
            <div className="flex-align mr-point gap-16">
              <Link
                to={`${isWholesale ? "/wholesale" : ""}/products`}
                className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
              >
                All Products
              </Link>
            </div>
          </div>
        </div>
        <div className="new-arrival__slider arrow-style-two">
          <Slider {...settings}>
            {Array.isArray(productRecommended) &&
              productRecommended.length > 0 &&
              productRecommended.map((product, index) => (
                <div key={product.id + index}>
                  <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-one-600 rounded-16 position-relative transition-2">
                    <Link
                      to={`${isWholesale ? "/wholesale" : ""}/product-details/${encodeURIComponent(
                        product?.slug
                      )}`}
                      className="product-card__thumb flex-center"
                    >
                      {product?.discountPrice > 0 &&
                        product?.discountPrice < product?.price && (
                          <span className="product-card__badge bg-danger-600 px-8 py-4 text-sm text-white position-absolute inset-inline-start-0 inset-block-start-0">
                            Sale{" "}
                            {formatNumberLocal(Number(product?.discount))}
                            %
                          </span>
                        )}

                      <img
                        src={
                          product.photoData && product.photoData.length > 0
                            ? product.photoData[0].url
                            : "/assets/images/no-image.png"
                        }
                        alt=""
                      />
                    </Link>
                    <div className="product-card__content p-sm-2">
                      <h6 className="title text-lg fw-semibold mt-12 mb-8">
                        <Link
                          to={`/product-details/${encodeURIComponent(
                            product?.slug
                          )}`}
                          className="link text-line-2"
                        >
                          {product.name || "Product Name"}
                        </Link>
                      </h6>
                      {/* <div className="flex-align gap-4">
                        <span className="text-main-one-600 text-md d-flex">
                          <i className="ph-fill ph-storefront" />
                        </span>
                        <span className="text-gray-500 text-xs">
                          By Lucky Supermarket
                        </span>
                      </div> */}
                      <div className="product-card__content mt-12">
                        <div className="product-card__price my-20">
                          {product?.discountPrice > 0 &&
                            product?.discountPrice < product?.price && (
                              <span className="text-gray-400 text-md fw-semibold text-decoration-line-through">
                                {formatCurrencyLocal(product?.price, "USD")}
                              </span>
                            )}

                          <span className="text-heading text-md fw-semibold ">
                            {formatCurrencyLocal(
                              product?.discountPrice > 0 &&
                                product?.discountPrice < product?.price
                                ? product?.discountPrice ?? 0
                                : product?.price ?? 0,
                              "USD",
                            )}{" "}
                            <span className="text-gray-500 fw-normal">
                              /Qty
                            </span>{" "}
                          </span>
                        </div>
                        <Link
                          to={`${isWholesale ? "/wholesale" : ""}/product-details/${encodeURIComponent(
                            product?.slug
                          )}`}
                          className="product-card__cart btn bg-main-one-50 text-main-one-600 hover-bg-main-one-600 hover-text-white py-11 px-24 rounded-pill flex-align gap-8 mt-24 w-100 justify-content-center"
                        >
                          View Detail
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default NewArrivalTwo;
